interface TimelineUpdateProps {
  title?: string;
  description?: string;
  updatedBy?: string;
  updateTime?: string;
  type?: "carrier" | "title";
  status?: "error" | "warn" | "default";
}

const statusStyle = {
  error:   { bg: "#FBEAE9", fill: "#CB1A14" },
  warn:    { bg: "#FEF6E7", fill: "#DD900D" },
  default: { bg: "#DBEAFE", fill: "#2563EB" },
};

export default function TimelineUpdate(props: TimelineUpdateProps) {
  const s = statusStyle[props.status ?? "default"];

  return (
    <div className="flex justify-between items-start">
      <div className="flex items-start gap-x-2">
        <div className="flex flex-col items-center">
          {props.type === "carrier" ? (
            <div
              className="w-[22px] h-[22px] rounded-full flex items-center justify-center flex-shrink-0"
              style={{ border: `1px solid ${s.fill}`, backgroundColor: s.bg }}
            >
              <svg width="12" height="12" viewBox="0 0 18 18" fill="none">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M5.25 15.75C6.22966 15.75 7.06309 15.1239 7.37197 14.25H12.128C12.4369 15.1239 13.2703 15.75 14.25 15.75C15.2297 15.75 16.0631 15.1239 16.372 14.25H16.5C16.9142 14.25 17.25 13.9142 17.25 13.5V10.9775C17.25 10.5577 17.1619 10.1426 16.9914 9.75907L16.2792 8.15658C15.7977 7.0732 14.7234 6.375 13.5378 6.375H12V5.25C12 3.59315 10.6569 2.25 9 2.25H3.75C2.09315 2.25 0.75 3.59315 0.75 5.25V12.75C0.75 13.5784 1.42157 14.25 2.25 14.25H3.12803C3.43691 15.1239 4.27034 15.75 5.25 15.75ZM2.25 5.25C2.25 4.42157 2.92157 3.75 3.75 3.75H9C9.82843 3.75 10.5 4.42157 10.5 5.25V12.75H7.37197C7.06309 11.8761 6.22966 11.25 5.25 11.25C4.27034 11.25 3.43691 11.8761 3.12803 12.75H2.25V5.25ZM15.6207 10.3683C15.706 10.5601 15.75 10.7676 15.75 10.9775V11.8229C15.3519 11.4666 14.8263 11.25 14.25 11.25C13.2703 11.25 12.4369 11.8761 12.128 12.75H12V7.875H13.5378C14.1306 7.875 14.6678 8.2241 14.9085 8.76579L15.6207 10.3683ZM4.5 13.5C4.5 13.0858 4.83579 12.75 5.25 12.75C5.66421 12.75 6 13.0858 6 13.5C6 13.9142 5.66421 14.25 5.25 14.25C4.83579 14.25 4.5 13.9142 4.5 13.5ZM13.5 13.5C13.5 13.0858 13.8358 12.75 14.25 12.75C14.6642 12.75 15 13.0858 15 13.5C15 13.9142 14.6642 14.25 14.25 14.25C13.8358 14.25 13.5 13.9142 13.5 13.5Z"
                  fill={s.fill}
                />
              </svg>
            </div>
          ) : (
            <div className="w-[22px] h-[22px] rounded-full border border-[#7C3AED] bg-[#EDE9FE] flex items-center justify-center flex-shrink-0">
              <svg width="11" height="13" viewBox="0 0 13 15" fill="none">
                <path
                  d="M6.75 0.75H2.08333C1.72971 0.75 1.39057 0.890476 1.14052 1.14052C0.890476 1.39057 0.75 1.72971 0.75 2.08333V12.75C0.75 13.1036 0.890476 13.4428 1.14052 13.6928C1.39057 13.9429 1.72971 14.0833 2.08333 14.0833H10.0833C10.437 14.0833 10.7761 13.9429 11.0261 13.6928C11.2762 13.4428 11.4167 13.1036 11.4167 12.75V5.41667M6.75 0.75L11.4167 5.41667M6.75 0.75V5.41667H11.4167"
                  stroke="#6D28D9"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          )}
          <div className="w-[2px] bg-[#E4E7EC] flex-1 mt-2" />
        </div>

        <div className="flex flex-col gap-y-1 pb-4">
          <h2 className="text-[#11121A] text-[12px] font-[500]">
            {props.title ?? "Shipment In-Transit Ocean"}
          </h2>
          <p className="text-gray-500 text-[12px]">
            {props.description ?? "Vehicle picked up from Copart auction lot"}
          </p>
          <div className="flex items-center gap-1">
            {props.updatedBy === "transporter" ? (
              <span className="bg-[#F9FAFB] border border-[#E4E7EC] p-1 rounded-full flex items-center px-2 text-[#667185] text-[10px] font-medium gap-1">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path
                    d="M6 9H6.005M3.5 1H8.5C9.05228 1 9.5 1.44772 9.5 2V10C9.5 10.5523 9.05228 11 8.5 11H3.5C2.94772 11 2.5 10.5523 2.5 10V2C2.5 1.44772 2.94772 1 3.5 1Z"
                    stroke="#667185"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                via Transporter Portal
              </span>
            ) : (
              <div className="flex items-center gap-1">
                <p className="text-[#6366F1] text-center font-semibold p-1 px-1.5 text-[8px] rounded-full bg-indigo-50">
                  {props.updatedBy?.[0]?.toUpperCase() ?? "D"}
                </p>
                <p className="text-gray-500 text-[10px]">
                  Updated by{" "}
                  <span className="font-medium">{props.updatedBy ?? ""}</span>
                </p>
              </div>
            )}
          </div>
        </div>
      </div>

      <p className="text-gray-500 text-[10px] whitespace-nowrap ml-2">
        {props.updateTime ?? "Today, 4:30PM"}
      </p>
    </div>
  );
}
